<template>
  <div v-if="finishedloading">
    <div v-if="!isAuthenticated" class="main-container">
      <PricingPreview />
    </div>
    <div v-if="isAuthenticated" class="main-container">
      <PricingView />
    </div>
  </div>
</template>

<script>
import Vue from 'vue';
import PricingPreview from '@/components/pricingAndTeamComponents/PricingPreview.vue';
import PricingView from '@/components/pricingAndTeamComponents/PricingView.vue';

export default Vue.extend({
  name: 'PricingScreen',
  components: {
    PricingPreview,
    PricingView
  },
  computed: {
    finishedloading: function() {
      return !this.$auth.loading
    },
    isAuthenticated: function() {
      return !this.$auth.loading && this.$auth.isAuthenticated;
    }
  }
})
</script>

<style scoped lang="scss">
@import '@/styles/pricing-screen.scss';
</style>
